import { FormGroup, ValidatorFn } from "@angular/forms";

export const AtLeastOneChecked: ValidatorFn = (formGroup: FormGroup) => {
    const atLeastOneChecked = Object.keys(formGroup.controls).length == 0 || Object.keys(formGroup.controls).filter(x => formGroup.controls[x].value).length;
    if (!atLeastOneChecked) {
      return { noOneChecked: true };
    }
    return null;
}